import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "../common/Styles";
import ChartTogglebar from "../common/ChartTogglebar";
import AboutTogglebar from "../common/AboutTogglebar";
import ChartView from "./ChartView";
import { charts, about } from "./constants";
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import AgricultureMetrics from "./AgricultureMetrics";
import MiniMetrics from "./MiniMetrics";

// const AgricultureView = ({ setScenarioDisabled }) => {
const AgricultureView = ({ setScenarioDisabled }) => {
  const classes = useStyles();
  const { chart_selected } = useSelector((state) => state.water_user);
  const { setWaterUserChart } = userActions();

  // useEffect(() => {
  //   setScenarioDisabled(charts[chart_selected].scenario_disabled);
  // }, [chart_selected]);

  const handleChange = (e, idx) => {
    setWaterUserChart(idx);
  };

  return (
    <Grid container item className={classes.mainView}>
      <ChartTogglebar
        charts={charts}
        value={chart_selected >= charts.length ? 0 : chart_selected}
        onChange={handleChange}
        setChart={setWaterUserChart}
      />
      <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
      <AboutTogglebar
        MetricsComponent={
          {
            0: <AgricultureMetrics />,
            1: <MiniMetrics />,
            2: <AgricultureMetrics />
          }[chart_selected >= charts.length ? 0 : chart_selected]
        }
        about={about[chart_selected >= charts.length ? 0 : chart_selected]}
      />
    </Grid>
  );
};

export default AgricultureView;
